import axios from 'axios'
import { SERVER_API_URL } from '../config/constants'

export const overrideAxiosDefaultConfig = () => {
  axios.defaults.baseURL = SERVER_API_URL
  axios.defaults.timeout = 5 * 60 * 1000
}
